<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div v-html="termsOfUse" v-if="settings">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "terms-of-use",
  data() {
    return {
      termsOfUse: "",
    }
  },
  async mounted() {
    this.termsOfUse = (await this.$store.dispatch("termsOfUse")).value
    this.changeAppHeaderText("terms-of-use");
  },
};
</script>
